module.exports = __webpack_public_path__ + "img/icon-checkmark.41372e83.svg";